<div class="main-container">
    <mat-toolbar>
        <img src="../../assets/Rapido.png" width="30" height="30" class="d-inline-block align-top" alt="" /><span class="rapido-form-field">&nbsp;Rapido Payroll Dashboard</span>
        
    </mat-toolbar>
    <button (click)="onSignInClick()">Sign in with Google</button>
</div>